module.exports = __webpack_public_path__ + "media/images/home/main/sakumlapa-d860eb902c1030cf5ac136a3d1187b6b.png";